import { IconUserFilled } from '@tabler/icons-react';
import styles from './AccountManagerDefaultAvatar.module.scss';
import clsx from 'clsx';

export function AccountManagerDefaultAvatar({ palette }: { palette: string }) {
  return (
    <div className={clsx(styles.avatarContainer, styles[palette])}>
      <IconUserFilled className={styles.avatar} />
    </div>
  );
}
